import React from 'react';
import Moment from 'moment';
import FormattedValue from './FormattedValue';

const ProductRow = ({ product, grouped }) => (
  <div className={`StockCurrentGroupedTable__grid ${grouped ? 'StockCurrentGroupedTable__grid--grouped' : ''} StockCurrentGroupedTable__product-row`}>
    <div className="StockCurrentGroupedTable__col--arrow" />
    <div className="StockCurrentGroupedTable__col--prod">{product.prod}</div>
    <div className="StockCurrentGroupedTable__col--cod">{product.cod}</div>
    {grouped ? (
      <div className="StockCurrentGroupedTable__col--right">{product.loteCount}</div>
    ) : (
      <React.Fragment>
        <div className="StockCurrentGroupedTable__col--lote">{product.lote}</div>
        <div className="StockCurrentGroupedTable__col--center">{Moment(product.expirationDate).format('DD/MM/YYYY')}</div>
      </React.Fragment>
    )}
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={product.pallets} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={product.volume} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={product.value} minFractionDigits={2} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={product.weight} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={product.quantity} /></div>
  </div>
);

export default ProductRow;
